module.exports = __webpack_public_path__ + "img/20190601135558QQ截图20190527164248.7ee2c44a.png";